/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Members_Resend_Invite_SuccessInputs */



/**
* | output |
* | --- |
* | "Invite email resent to {email}." |
*
* @param {Members_Resend_Invite_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_resend_invite_success = /** @type {((inputs: Members_Resend_Invite_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Resend_Invite_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Einladungs-E-Mail erneut an ${i?.email} gesendet.`)
	return /** @type {LocalizedString} */ (`Invite email resent to ${i?.email}.`)
});